import {
  SET_PORTABILITY,
  SET_ADDICIONAL_NUMBERS,
  UPDATE_ADDITIONAL_PLAN_VALUE,
  UPDATE_PORTABILITY_INFO_VALUE,
  SET_AVAILABLE_NUMBERS,
  SET_CHOSEN_NUMBER,
  SET_PAYMENT_ENTITY,
  SET_PAYMENT_REF,
  SET_PAYMENT_TOTAL,
  SET_LAST_SESSION_ID
} from './types';

export default {
  [SET_PORTABILITY](state, payload) {
    state.portability = payload;
  },

  [SET_ADDICIONAL_NUMBERS](state, payload) {
    state.addicionalNumbers = payload;
  },

  [UPDATE_ADDITIONAL_PLAN_VALUE](state, payload) {
    const position = state.addicionalNumbers.findIndex(plan => plan.phone === payload.plan.phone);
    state.addicionalNumbers[position][payload.key] = payload.value;
  },

  [UPDATE_PORTABILITY_INFO_VALUE](state, payload) {
    state.portabilityInfo[payload.key] = payload.value;
  },

  [SET_AVAILABLE_NUMBERS](state, payload) {
    state.availableNumbers = payload;
  },

  [SET_CHOSEN_NUMBER](state, payload) {
    state.chosenNumber = payload;
  },

  [SET_PAYMENT_ENTITY](state, payload) {
    state.paymentInfo.entity = payload;
  },

  [SET_PAYMENT_REF](state, payload) {
    state.paymentInfo.ref = payload;
  },

  [SET_PAYMENT_TOTAL](state, payload) {
    state.paymentInfo.total = payload;
  },

  [SET_LAST_SESSION_ID](state, payload) {
    state.lastSessionId = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/movel/mutations.js